import outlet from "fragments/news/outlet"
import { gql } from "graphql-tag"

const UPDATE_OUTLET = gql`
  ${outlet}

  mutation updateOutlet($id: ID!, $outletUpdateInput: OutletUpdateInput!) {
    updateOutlet(id: $id, outletUpdateInput: $outletUpdateInput) {
      ...Outlet
    }
  }
`

export default UPDATE_OUTLET
